import V from 'voca';
import ExpandableTextComponent from '72cms-ui/components/form-elements/ExpandableTextComponent';
import CustomRadioComponent from '72cms-ui/components/form-elements/CustomRadioComponent';

export default {
    sections: ['details'],
    groups: {
        settings: {
            component: {
                template: `<div>
                    <div class="form-row"><slot name="required" /></div>
                    <div class="form-row"><slot name="auto_populated" /></div>
                </div>`
            }
        }
    },
    toolbar: ['edit', 'active', 'delete'],
    fields: {
        title: {
            label: 'Field label',
            section: 'details',
            isRequired: true,
            position: 0,
        },

        name: {
            label: 'Field name',
            section: 'details',
            isRequired: true,
            position: 1,
        },

        data_type: {
            label: 'Field type',
            section: 'details',
            isRequired: true,
            position: 2,
        },

        refs: {
            label: 'Field refs',
            section: 'details',
            position: 3,
            component: CustomRadioComponent,
            values: ['dealers'],
            disabled: function (value, schema, data) {
                return data.data_type != 'refs-selectbox';
            },
            listener: function (entry, entries, $form) {
                const value = entry.newValue || entry.value;
                if (entry.name == 'data_type') {
                    this.disabled = (value != 'refs-selectbox');
                }
            },
        },

        required: {
            label: 'Is this field required?',
            section: 'details',
            group: 'settings',
            cssClass: 'col-md-6',
            position: 3,
        },

        values: {
            label: 'Field values',
            section: 'details',
            component: ExpandableTextComponent,
            position: 6,
            disabled: function (value, schema, data) {
                return data.data_type != 'selectbox';
            },
            listener: function (entry, entries, $form) {
                const value = entry.newValue || entry.value;
                if (entry.name == 'data_type') {
                    this.disabled = (value != 'selectbox');
                }
            },
        },
    }
}



// WEBPACK FOOTER //
// ./resources/assets/cms/js/config/form.panel-form-panel_form_field.js